// import { useState } from 'react'
// import * as con from '../../GlobalConstants.js'
// import { GenericCell } from '../../templates/tables/Cells.js'
// import Modal from '../../templates/popups/Modal.js'
// import LoadingOverlay from '../modales/LoadingOverlay.js'

// const INSTRUMENT_LABEL = {
//   [con.SPOT]:    'Spot',
//   [con.FWDS]:    'Forward',
//   [con.OPTIONS]: 'Collares',
// }

// const GridWarningsModal = ({ warnings, onAccept, onEdit }) => {
//   const [editedBullets, setEditedBullets] = useState(() =>
//     Object.fromEntries(
//       warnings.map((w) => [`${w[con.STEP]}_${w[con.INSTRUMENT]}`, w[con.MAX_BULLET]])
//     )
//   )
//   const [isLoading, setIsLoading] = useState(false)

//   const handleBulletChange = (step, instrument, value) => {
//     setEditedBullets(prev => ({
//       ...prev,
//       [`${step}_${instrument}`]: Number(value) || 0
//     }))
//   }

//   const isBlocked = warnings.some((w) => {
//     const key = `${w[con.STEP]}_${w[con.INSTRUMENT]}`
//     return editedBullets[key] > w[con.MAX_BULLET]
//   })

//   const handleGenerate = async () => {
//     setIsLoading(true)
//     await onEdit(editedBullets)
//     setIsLoading(false)
//   }

//   if (isLoading) return <LoadingOverlay />

//   return (
//     <Modal
//       show={true}
//       doAccept={onAccept}
//       doCancel={null}
//       showAccept={true}
//       showCancel={false}
//       acceptText="Aceptar grilla actual"
//       widthPercentage={70}
//     >
//       <div style={{ padding: "8px" }}>
//         <h3 style={{ marginBottom: "16px" }}>
//           Advertencias de frecuencia
//         </h3>
//         <p style={{ marginBottom: "16px", fontSize: "13px", color: "var(--text-color-2)" }}>
//           Los siguientes escalones tienen una frecuencia superior a la máxima permitida.
//           Puedes: <br/>
//           1. Modificar el monto máximo antes de generar.<br/>
//           2. Aceptar la grilla actual ya generada
//         </p>

//         <table className="nonFixedTable">
//           <thead>
//             <tr className="header-row">
//               <th>Escalón</th>
//               <th>Instrumento</th>
//               <th>Frecuencia actual</th>
//               <th>Monto actual</th>
//               <th>Monto máx</th>
//             </tr>
//           </thead>
//           <tbody>
//             {warnings.map((w, index) => {
//               const isEven     = index % 2 === 1
//               const step       = w[con.STEP]
//               const instrument = w[con.INSTRUMENT]
//               const key        = `${step}_${instrument}`
//               const isOverMax  = editedBullets[key] > w[con.MAX_BULLET]

//               return (
//                 <tr key={key} className={isEven ? 'even-row' : 'uneven-row'}>
//                   <td>
//                     <GenericCell
//                       evenRow={isEven}
//                       cellType={con.TEXT}
//                       editing={false}
//                       value={step}
//                     />
//                   </td>
//                   <td>
//                     <GenericCell
//                       evenRow={isEven}
//                       cellType={con.TEXT}
//                       editing={false}
//                       value={INSTRUMENT_LABEL[instrument] ?? instrument}
//                     />
//                   </td>
//                   <td>
//                     <GenericCell
//                       evenRow={isEven}
//                       cellType={con.NUMERIC}
//                       editing={false}
//                       value={Number(w[con.FREQUENCY].toFixed(2))}
//                     />
//                   </td>
//                   <td>
//                     <GenericCell
//                       evenRow={isEven}
//                       cellType={con.MONEY}
//                       currency={con.MONEY_COP}
//                       editing={false}
//                       value={w[con.BULLET]}
//                     />
//                   </td>
//                   <td>
//                     <div style={{ position: 'relative' }}>
//                       <GenericCell
//                         evenRow={isEven}
//                         cellType={con.MONEY}
//                         currency={con.MONEY_COP}
//                         editing={true}
//                         value={editedBullets[key]}
//                         setValue={(val) => handleBulletChange(step, instrument, val)}
//                       />
//                       {isOverMax && (
//                         <div style={{
//                           fontSize: "11px",
//                           color: "red",
//                           marginTop: "2px"
//                         }}>
//                           Supera el monto máximo
//                         </div>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               )
//             })}
//           </tbody>
//         </table>

//         <div style={{ marginTop: "16px", display: "flex", justifyContent: "flex-end" }}>
//           <div title={isBlocked ? "Bloqueado porque el monto ingresado es mayor al monto máximo" : ""}>
//             <button
//               className="control-button"
//               onClick={handleGenerate}
//               disabled={isBlocked}
//               style={{
//                 fontSize: "14px",
//                 padding: "6px 16px",
//                 fontWeight: "bold",
//                 backgroundColor: isBlocked ? "#aaa" : "var(--background-color-3)",
//                 color: "white",
//                 cursor: isBlocked ? "not-allowed" : "pointer",
//                 border: "none",
//                 borderRadius: "5px",
//               }}
//             >
//               Generar
//             </button>
//           </div>
//         </div>

//       </div>
//     </Modal>
//   )
// }

// export default GridWarningsModal

import { useState } from 'react'
import * as con from '../../GlobalConstants.js'
import { GenericCell } from '../../templates/tables/Cells.js'
import Modal from '../../templates/popups/Modal.js'
import LoadingOverlay from '../modales/LoadingOverlay.js'

const INSTRUMENT_LABEL = {
  [con.SPOT]:    'Spot',
  [con.FWDS]:    'Forward',
  [con.OPTIONS]: 'Collares',
}

const GridWarningsModal = ({ warnings, onAccept, onEdit }) => {
  const [editedBullets, setEditedBullets] = useState(() =>
    Object.fromEntries(
      warnings.map((w) => [`${w[con.STEP]}_${w[con.INSTRUMENT]}`, w[con.MAX_BULLET]])
    )
  )
  const [isLoading, setIsLoading] = useState(false)

  const handleBulletChange = (step, instrument, value) => {
    setEditedBullets(prev => ({
      ...prev,
      [`${step}_${instrument}`]: Number(value) || 0
    }))
  }

  const isBlocked = warnings.some((w) => {
    const key = `${w[con.STEP]}_${w[con.INSTRUMENT]}`
    return editedBullets[key] > w[con.MAX_BULLET]
  })

  const handleGenerate = async () => {
    setIsLoading(true)
    await onEdit(editedBullets)
    setIsLoading(false)
  }

  if (isLoading) return <LoadingOverlay />

  return (
    <Modal
      show={true}
      doAccept={null}
      doCancel={null}
      showAccept={false}
      showCancel={false}
      widthPercentage={70}
    >
      <div style={{ padding: "8px" }}>
        <h3 style={{ marginBottom: "16px" }}>
          Advertencias de frecuencia
        </h3>
        <p style={{ marginBottom: "16px", fontSize: "13px", color: "var(--text-color-2)" }}>
          Los siguientes escalones tienen una frecuencia superior a la máxima permitida.
          Puedes: <br/>
          1. Modificar el monto máximo antes de generar.<br/>
          2. Aceptar la grilla actual ya generada.
        </p>

        <table className="nonFixedTable">
          <thead>
            <tr className="header-row">
              <th>Escalón</th>
              <th>Instrumento</th>
              <th>Frecuencia actual</th>
              <th>Monto actual</th>
              <th>Monto máx</th>
            </tr>
          </thead>
          <tbody>
            {warnings.map((w, index) => {
              const isEven     = index % 2 === 1
              const step       = w[con.STEP]
              const instrument = w[con.INSTRUMENT]
              const key        = `${step}_${instrument}`
              const isOverMax  = editedBullets[key] > w[con.MAX_BULLET]

              return (
                <tr key={key} className={isEven ? 'even-row' : 'uneven-row'}>
                  <td>
                    <GenericCell
                      evenRow={isEven}
                      cellType={con.TEXT}
                      editing={false}
                      value={step}
                    />
                  </td>
                  <td>
                    <GenericCell
                      evenRow={isEven}
                      cellType={con.TEXT}
                      editing={false}
                      value={INSTRUMENT_LABEL[instrument] ?? instrument}
                    />
                  </td>
                  <td>
                    <GenericCell
                      evenRow={isEven}
                      cellType={con.NUMERIC}
                      editing={false}
                      value={Number(w[con.FREQUENCY].toFixed(2))}
                    />
                  </td>
                  <td>
                    <GenericCell
                      evenRow={isEven}
                      cellType={con.MONEY}
                      currency={con.MONEY_COP}
                      editing={false}
                      value={w[con.BULLET]}
                    />
                  </td>
                  <td>
                    <div style={{ position: 'relative' }}>
                      <GenericCell
                        evenRow={isEven}
                        cellType={con.MONEY}
                        currency={con.MONEY_COP}
                        editing={true}
                        value={editedBullets[key]}
                        setValue={(val) => handleBulletChange(step, instrument, val)}
                      />
                      {isOverMax && (
                        <div style={{ fontSize: "11px", color: "red", marginTop: "2px" }}>
                          Supera el monto máximo
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>

        {/* ── Botones en la misma línea ── */}
        <div style={{ marginTop: "16px", display: "flex", justifyContent: "flex-end", gap: "12px" }}>
          <button
            className="control-button"
            onClick={onAccept}
            style={{
              fontSize: "14px",
              padding: "6px 16px",
              fontWeight: "bold",
              backgroundColor: "var(--background-color-3)",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Aceptar grilla actual
          </button>

          <div title={isBlocked ? "Bloqueado porque el monto ingresado es mayor al monto máximo" : ""}>
            <button
              className="control-button"
              onClick={handleGenerate}
              disabled={isBlocked}
              style={{
                fontSize: "14px",
                padding: "6px 16px",
                fontWeight: "bold",
                backgroundColor: isBlocked ? "#aaa" : "var(--background-color-3)",
                color: "white",
                cursor: isBlocked ? "not-allowed" : "pointer",
                border: "none",
                borderRadius: "5px",
              }}
            >
              Generar
            </button>
          </div>
        </div>

      </div>
    </Modal>
  )
}

export default GridWarningsModal